import React from 'react'
import { css } from '@emotion/react'
import {Typography} from '../base-ui'

function ThemeCard({ title, uptitle, content, action, bgImageUrl, style = {bgColor: '', color: ''} }) {
    const cardStyle = css`
        display: flex;
        flex-direction: column;
        align-self: center;
        justify-content: center;
        flex-wrap: wrap;
        min-height: 500px;
        padding: 3.75rem;
        background-color: ${style.bgColor};
        ${bgImageUrl && `background-image: url(${bgImageUrl})`};
        background-repeat: no-repeat;
        background-size: cover;
        color: ${style.color};
        .cardUptitle {
            margin-bottom: 0;
        }
        .cardTitle, .content {
            margin-bottom: 20px;
        }
    `
    return (
        <div css={cardStyle}>
            <Typography fontSize="2.2rem" color={style.color} type="h4" className="cardUptitle">{uptitle}</Typography>
            <Typography fontSize="3.2rem" color={style.color} type="h3" className="cardTitle">{title}</Typography>
            <Typography color={style.color} type="p" className="content">{content}</Typography>
            <div className="action">{action}</div>
        </div>
    )
}

export default ThemeCard